import {
  BodySmallText,
  FontEmphasis,
  FontScale,
} from '@prisjakt/ui/text/variants';
import React, { memo, useContext } from 'react';
import { AppContext } from 'src/components/app-context';
import { StoreStatistics } from 'src/types';
import {
  StyledInfoPageLinkWrapper,
  StyledPriceInformation,
  StyledInfoPageLink,
} from './styles';

const PriceInformation: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceInformationProps>
>> = props => {
  const { t, market } = useContext(AppContext);

  return (
    <StyledPriceInformation>
      <BodySmallText emphasis={FontEmphasis.MEDIUM} scale={FontScale.XS}>
        {t('product', 'price-comparison-information.featured-stores-ratio', {
          totalCount: props.storeStatistics?.totalCount || 0,
          featuredCount: props.storeStatistics?.featuredCount || 0,
        })}
        <br />
        {t('product', 'price-comparison-information.listed-stores-information')}
      </BodySmallText>
      <StyledInfoPageLinkWrapper>
        <StyledInfoPageLink id={market.infoPageMap?.priceInformation}>
          <BodySmallText emphasis={FontEmphasis.MEDIUM} scale={FontScale.XS}>
            {t('product', 'price-comparison-information.read-more')}
          </BodySmallText>
        </StyledInfoPageLink>
      </StyledInfoPageLinkWrapper>
    </StyledPriceInformation>
  );
};

interface IPriceInformationProps {
  storeStatistics: StoreStatistics;
}

export default memo(PriceInformation);
